import guideDataJson from '../data/guide-data.json';

export interface GuideData {
  country: string;
  title: string;
  properties: {
    name: string;
    value: string;
  }[];
}

export interface GuideDataCollection {
  countries: Record<string, GuideData>;
}

/**
 * Get guide data for a specific country
 * @param countryCode - The country code (e.g., 'USA', 'GBR')
 * @returns GuideData for the specified country or undefined if not found
 */
export const getGuideDataByCountry = (countryCode: string): GuideData | undefined => {
  const data = guideDataJson as GuideDataCollection;
  return data.countries[countryCode.toUpperCase()];
};

/**
 * Get all available country codes
 * @returns Array of available country codes
 */
export const getAvailableCountries = (): string[] => {
  const data = guideDataJson as GuideDataCollection;
  return Object.keys(data.countries);
};

/**
 * Get all guide data
 * @returns Complete guide data collection
 */
export const getAllGuideData = (): GuideDataCollection => {
  return guideDataJson as GuideDataCollection;
};